// Info: Import React Dependancies
import React, { useState, useRef, useEffect, SetStateAction } from 'react';
import { TextArea } from '@enbdleap/react-ui';
// Info: Import NPM Dependancies
import ConditionallyRender from 'react-conditionally-render';
import { RenderFunc } from 'react-conditionally-render/dist/src/types';
import { useDispatch, useSelector } from 'react-redux';
import { createAdobeData } from '../../services/adobeUtil';
// Info: Import Local Dependancies
import UserChatMessage from '../UserChatMessage/UserChatMessage';
import ChatbotMessage from '../ChatbotMessage/ChatbotMessage';
import {
  botMessage,
  userMessage,
  customMessage,
  createChatMessage,
} from './chatUtils';
import '../../assets/css/style.css';
import {
  IBackgroundColor,
  ICustomComponents,
  ICustomMessage,
  ICustomStyles,
} from '../../interfaces/IConfig';
import { IMessage } from '../../interfaces/IMessages';
import { IFaq, ROLE_TYPE, useProxyServices } from '../../services/useProxyService';
import { getAuthToken, getChatContent, getErrorMessage ,getMessages} from '../../store/sitecoreSlice';
import { checkDomPurify, purifyHTML } from '../../services/Util';
import ChatbotError from '../ChatbotError/ChatbotError';
import { getIsMessageLoaded, setIsMessageLoaded } from '../../store/feedbackSlice';
import { useLocation, useSearchParams } from 'react-router-dom';

const LikeImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path d="M6.5 15.5V6.50001C6.5 5.39544 5.60457 4.50001 4.5 4.50001H2.5C1.39543 4.50001 0.5 5.39544 0.5 6.50001V15.5C0.5 16.6046 1.39543 17.5 2.5 17.5H4.5C5.60457 17.5 6.5 16.6046 6.5 15.5ZM6.5 15.5L7.24732 16.3899C7.49147 16.6806 7.77002 16.9472 8.11272 17.1106C8.64824 17.3659 9.23616 17.5 9.83421 17.5H13.5C15.3355 17.5 17.3738 16.2508 17.819 14.4701L19.4403 7.98507C19.7559 6.72278 18.8011 5.5 17.5 5.5H11.6213L13.0301 3.38675C14.1377 1.72536 12.9967 0.5 11 0.5H9.5L6.7 4.23333C6.57018 4.40643 6.5 4.61705 6.5 4.83342C6.5 5.14919 6.5 5.36818 6.5 5.5V13.5C6.5 13.8344 6.5 14.5 6.5 15.5Z" stroke="#001F47" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
const DisLikeImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path d="M13.501 2.5V11.5C13.501 12.6046 14.3964 13.5 15.501 13.5H17.501C18.6056 13.5 19.501 12.6046 19.501 11.5V2.5C19.501 1.39543 18.6056 0.5 17.501 0.5H15.501C14.3964 0.5 13.501 1.39543 13.501 2.5ZM13.501 2.5L12.7537 1.61011C12.5095 1.31938 12.231 1.05278 11.8883 0.889393C11.3527 0.634062 10.7648 0.5 10.1668 0.5H6.50099C4.66551 0.5 2.62714 1.7492 2.18197 3.52987L0.5607 10.0149C0.245127 11.2772 1.19984 12.5 2.50098 12.5H8.37972L6.97088 14.6133C5.86329 16.2746 7.00425 17.5 9.00099 17.5H10.501L13.301 13.7667C13.4308 13.5936 13.501 13.383 13.501 13.1666C13.501 12.8508 13.501 12.6318 13.501 12.5V4.50001C13.501 4.16565 13.501 3.5 13.501 2.5Z" stroke="#001F47" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
interface IChatProps {
  setState: React.Dispatch<SetStateAction<any>>;
  widgetRegistry: any;
  messageParser: any;
  actionProvider: any;
  customComponents: ICustomComponents;
  botName: string;
  customStyles: ICustomStyles;
  headerText: string;
  customMessages: ICustomMessage;
  placeholderText: string;
  validator?: (input: string) => Boolean;
  state: any;
  disableScrollToBottom: boolean;
  messageHistory: IMessage[] | string;
  parse?: (message: string) => void;
  actions?: object;
  messageContainerRef: React.MutableRefObject<HTMLDivElement>;
  loading?: boolean;
}
const Chat = ({
  state,
  setState,
  widgetRegistry,
  messageParser,
  parse,
  customComponents,
  actionProvider,
  botName,
  customStyles,
  headerText,
  customMessages,
  placeholderText,
  validator,
  disableScrollToBottom,
  messageHistory,
  actions,
  messageContainerRef,
  loading
}: IChatProps) => {
  const dispatch = useDispatch();
  const { getFaq, deleteMessageHistory } = useProxyServices()
  const { messages } = state;
  const [input, setInputValue] = useState('');
  const [isNewSession, setIsNewSession] = useState(false);
  const [isDisLike, setIsDisLike] = useState(false);
  const [faqs, setFaqs] = useState<IFaq | null>(null);
  const isErrorMessage = useSelector(getErrorMessage);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  let isLoading = useSelector(getIsMessageLoaded);//messages?.[messages.length - 1]?.loading
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchParams] = useSearchParams();
  const authToken = useSelector(getAuthToken)

  useEffect(() => {
    isLoading && setIsInputDisabled(false);
    setTimeout(() => {
      inputRef?.current?.focus();
    }, 0);
  }, [isLoading])
  const scrollIntoView = () => {
    setTimeout(() => {

      if (messageContainerRef.current) {
        messageContainerRef.current.scrollTop =
          messageContainerRef?.current?.scrollHeight;
      }
    }, 50);
  };
  const getQuestions = async () => {
    const res = await getFaq()
    if (res?.questions.length) {
      setFaqs(res)
    }
  }
  useEffect(() => {
    if (authToken)
    getQuestions()

  }, [authToken]);
  useEffect(() => {

    if (disableScrollToBottom) return;
    scrollIntoView();
  });

  const showAvatar = (messages: any[], index: number) => {
    if (index === 0) return true;

    const lastMessage = messages[index - 1];

    if (lastMessage.type === ROLE_TYPE.ASSISTANT && !lastMessage.widget) {
      return false;
    }
    return true;
  };

  const renderMessages = () => {
    return messages.map((messageObject: IMessage, index: number) => {
      if (botMessage(messageObject)) {
        return (
          <React.Fragment key={messageObject.id}>
            {renderChatbotMessage(messageObject, index)}
          </React.Fragment>
        );
      }

      if (userMessage(messageObject)) {
        return (
          <React.Fragment key={messageObject.id}>
            {renderUserMessage(messageObject)}
          </React.Fragment>
        );
      }

      if (customMessage(messageObject, customMessages)) {
        return (
          <React.Fragment key={messageObject.id}>
            {renderCustomMessage(messageObject)}
          </React.Fragment>
        );
      }
    });
  };

  const renderCustomMessage = (messageObject: IMessage) => {
    const customMessage = customMessages[messageObject.type];

    const props = {
      setState,
      state,
      scrollIntoView,
      actionProvider,
      payload: messageObject.payload,
      actions,
    };

    if (messageObject.widget) {
      const widget = widgetRegistry.getWidget(messageObject.widget, {
        ...state,
        scrollIntoView,
        payload: messageObject.payload,
        actions,
      });
      return (
        <>
          {customMessage(props)}
          {widget ? widget : null}
        </>
      );
    }

    return customMessage(props);
  };

  const renderUserMessage = (messageObject: IMessage) => {
    const widget = widgetRegistry.getWidget(messageObject.widget, {
      ...state,
      scrollIntoView,
      payload: messageObject.payload,
      actions,
    });
    return (
      <>
        <UserChatMessage
          message={messageObject.message}
          key={messageObject.id}
          customComponents={customComponents}
        />
        {widget ? widget : null}
      </>
    );
  };

  const renderChatbotMessage = (messageObject: IMessage, index: number) => {
    let withAvatar;
    if (messageObject.withAvatar) {
      withAvatar = messageObject.withAvatar;
    } else {
      withAvatar = showAvatar(messages, index);
    }

    const chatbotMessageProps = {
      ...messageObject,
      setState,
      state,
      customComponents,
      widgetRegistry,
      messages,
      actions,
    };

    if (messageObject.widget) {
      const widget = widgetRegistry.getWidget(chatbotMessageProps.widget, {
        ...state,
        scrollIntoView,
        payload: messageObject.payload,
        actions,
      });
      return (
        <>
          <ChatbotMessage
            customStyles={customStyles.botMessageBox as IBackgroundColor}
            withAvatar={withAvatar}
            {...chatbotMessageProps}
            key={messageObject.id}
          />
          <ConditionallyRender
            condition={!chatbotMessageProps.loading}
            show={widget ? widget : null}
          />
        </>
      );
    }

    return (
      <ChatbotMessage
        customStyles={customStyles.botMessageBox as IBackgroundColor}
        key={messageObject.id}
        withAvatar={withAvatar}
        {...chatbotMessageProps}
        customComponents={customComponents}
        messages={messages}
        setState={setState}
      />
    );
  };

  const handleSubmit = (e: React.FormEvent, queryType: string) => {
    e.preventDefault();
    if (!input) {
      return false;
    }
    if (!checkDomPurify(input)) {
      return false;
    }
    dispatch(setIsMessageLoaded(false))
    setIsInputDisabled(true)
    hideInfo();

    // createAdobeData(
    //   "ctaClick_chatbot_query", // event
    //   "Sustainability", // pageName
    //   queryType, // searchType
    //   input, // query
    //   "", // feedback
    //   "" // comment
    // );
    setIsNewSession(false)
    setIsLike(false)
    setIsDisLike(false)
    if (validator && typeof validator === 'function') {
      if (validator(input)) {
        handleValidMessage();
        if (parse) {
          return parse(input);
        }
        messageParser.parse(input);
      }
    } else {
      handleValidMessage();
      if (parse) {
        return parse(input);
      }
      messageParser.parse(input);
    }
  };

  const handleValidMessage = () => {
    setState((state: any) => ({
      ...state,
      messages: [...state.messages, createChatMessage(input, 'user')],
    }));

    scrollIntoView();
    setInputValue('');

  };

  const customButtonStyle = { backgroundColor: '' };
  if (customStyles && customStyles.chatButton) {
    customButtonStyle.backgroundColor = customStyles.chatButton.backgroundColor;
  }

  const chatContent = useSelector(getChatContent)
  const chatMessages = useSelector(getMessages)
  const [showInfo, showInfoState] = useState(false);
  const [isLike, setIsLike] = useState<true | false | undefined>(undefined);
  function hideInfo() {
    showInfoState((showInfo) => true);
  }
  function  displayInfo() {
    showInfoState((showInfo) => false);
  }
  let header = `Conversation with ${botName}`;
  if (headerText) {
    header = headerText;
  }

  let placeholder = 'Write your message here';
  if (placeholderText) {
    placeholder = placeholderText;
  }
  // const userId = useLocation().pathname.replace('/en/', '');
  const userId = searchParams.get('uid');
 
  const  clearChat = async () => {

    setIsInputDisabled(true)
   await deleteMessageHistory(userId as string);
    displayInfo();
    setIsInputDisabled(false)
    setState((prev: any) => ({
      ...prev,
      messages: []
    }))
  };

  const handleLike = () => {
    createAdobeData(
      "ctaClick_chatbot_feedback", // event
      "Sustainability", // pageName
      "Manual", // searchType
      "", // query
      "like", // feedback
      "" // comment
    );
    setIsLike(true)
    setIsDisLike(false);
  }
  const handleDisLike = () => {

    createAdobeData(
      "ctaClick_chatbot_feedback", // event
      "Sustainability", // pageName
      "Manual", // searchType
      "", // query
      "Dislike", // feedback
      "" // comment
    );
    //setIsFeedBackAvailable(true);
    setIsLike(false)
    setIsDisLike(true);
  }
  const isValidUserId = (id: string) => {
    if (!/^\d+$/.test(id)) {
      return false;  // Ensure it contains only digits
    }
    // Convert the string to a number safely
    const numericId = BigInt(id).toString();
    // Get the length dynamically and create the regex pattern
       const userIdRegex = new RegExp(chatMessages.inputValidationLength);
        return userIdRegex.test(numericId);
   };

 
  const isUser = userId !== null && userId !== '' &&isValidUserId(userId);

  return (
    <div className="chatbot-container">

      <ConditionallyRender
        condition={!!customComponents.header}
        show={
          customComponents.header ? customComponents.header(actionProvider) as JSX.Element | RenderFunc : <></>
        }
        elseShow={
          <div className="chatbot-header chatbot-display-center">
            {chatContent?.icon && <img src={chatContent.icon} alt="enbd logo chatbot" />}

            {/* <a href="" className="chatbot-close-icon">
              {chatContent?.chatCloseIcon && <img src={chatContent.chatCloseIcon} alt="Chatbot close" />}
            </a> */}

          </div>
        }
      />
      {isErrorMessage || !isUser ? (
        <ChatbotError message={chatMessages.globalError} />
      ) : (<>
        <div className="chatbot-body" ref={showInfo ? messageContainerRef : null}>
          <div className="chatbot-entry" style={{ display: showInfo ? "none" : "" }}>
            <div className="chatbot-entry-fetured">
              <div className="chatbot-search-icon">
                {chatContent?.chatImage && <img src={chatContent.chatImage} alt="Search Icon" />}

              </div>
              <h1>{chatContent?.chatTitle}</h1>
              <p>{chatContent?.chatDescription}</p>
            </div>
            <div className="chatbot-entry-cards">
              <form
                className=""
                onSubmit={(e) => handleSubmit(e, "Suggested Content")}
              >
                {faqs != null && faqs?.questions?.length > 0 ? (
                  faqs.questions.map((question: any) => (
                    <div className="chatbot-entry-card-holder">
                      <button>
                        <a href="javascript:void(0)" className="chatbot-entry-card-link" >
                          <picture className="chatbot-entry-card-icon">
                            {chatContent?.chatIcon && <img src={chatContent.chatIcon} alt="Card Icon" />}
                          </picture>
                          <p> {question}      </p>
                          <a onClick={() => {
                            setInputValue(question)
                          }} className="stretched-link"></a>
                        </a>
                      </button>
                    </div>
                  ))) :
                  (
                    chatContent?.questions?.map((question: any) => (

                      <div className="chatbot-entry-card-holder">
                        <button>
                          <a href="javascript:void(0)" className="chatbot-entry-card-link" >
                            <picture className="chatbot-entry-card-icon">
                              {chatContent?.chatIcon && <img src={chatContent.chatIcon} alt="Card Icon" />}
                            </picture>
                            <p> {question.text}      </p>
                            <a onClick={() => {
                              setInputValue(question.text)
                            }} className="stretched-link"></a>
                          </a>
                        </button>
                      </div>
                    )
                    ))}

              </form>

            </div>
            <div className='chatbot-footer__disclaimer' dangerouslySetInnerHTML={{ __html: purifyHTML(chatMessages.disclaimer as string) }}></div>
          </div>
          <div
            className="chatbot-profile-holder"
            style={{ display: showInfo ? "" : "none" }}
          >
            <ConditionallyRender
              condition={
                typeof messageHistory === 'string' && Boolean(messageHistory)
              }
              show={
                <div
                  dangerouslySetInnerHTML={{ __html: purifyHTML(messageHistory as string) }}
                />
              }
            />
            {renderMessages()}
            <div style={{ paddingBottom: '2rem' }} />
           
            <div className="chatbot-vote-widget chatbot-display-center">

              {isLoading && (
                <>
                  <div className="chatbot-likedislike">
                    <a href="javascript:void(0)" className={isLike === true ? "active" : ""} onClick={handleLike}>
                      {chatContent?.likeImage && <LikeImg />}
                    </a>
                    <a href="javascript:void(0)" className={isDisLike === true ? "active" : ""} onClick={handleDisLike}>
                      {chatContent?.unlikeImage && <DisLikeImg />}
                    </a>

                  </div>
                  <div className="chatbot-clearchat">
                    {!isNewSession && <a href="javascript:void(0)" onClick={() => clearChat()}>{chatContent.clearChat}</a>}

                  </div></>)}
            </div>
            
            {isLike && <div style={{ marginTop: "1rem", textAlign: "center" }}>{chatMessages?.like}</div>}
            {isDisLike && <div style={{ marginTop: "1rem", textAlign: "center" }}>{chatMessages?.disLike} </div>}
            {isNewSession && <div style={{ textAlign: "center", borderTop: '1px dashed black', paddingTop: '1rem', marginTop: '1rem' }}>{chatMessages?.clearChat}</div>}


          </div>

        </div>

        <div className="chatbot-footer">
         
        
         <div className="chatbot-footer-holder chatbot-display-center">
            <form
              className=""
              onSubmit={(e) => handleSubmit(e, "Manual")}

            >
              <input ref={inputRef}
                className=""
                placeholder={chatContent.footerTitle}
                value={input}
                onChange={(e) => setInputValue(e.target.value)}
                disabled={isInputDisabled}
              />
              <button
                className="chatbot-button-holder"
                style={customButtonStyle}
                disabled={isInputDisabled}
              >
                {chatContent?.footerImage && <img src={chatContent.footerImage} alt="user image" />}


              </button>
            </form>
          </div>
        </div>
      </>)}
    </div>
  );
};

export default Chat;
